import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrganisationShippingAddressAddPage } from 'src/app/modals/organisation-shipping-address-add/organisation-shipping-address-add.page';

const routes: Routes = [
  {
    path: '',
    component: OrganisationShippingAddressAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrganisationShippingAddressAddPage]
})
export class OrganisationShippingAddressAddPageModule {}
